import billing from './en-US/billing';
import cdn from './en-US/cdn';
import cloak from './en-US/cloak';
import common from './en-US/common';
import component from './en-US/component';
import globalHeader from './en-US/globalHeader';
import menu from './en-US/menu';
import oss from './en-US/oss';
import pages from './en-US/pages';
import pwa from './en-US/pwa';
import resourceAdmin from './en-US/resourceAdmin';
import settingDrawer from './en-US/settingDrawer';
import settings from './en-US/settings';
import wallet from './en-US/wallet';

export default {
  'navBar.lang': 'Languages',
  'layout.user.link.help': 'Help',
  'layout.user.link.privacy': 'Privacy',
  'layout.user.link.terms': 'Terms',
  'app.preview.down.block': 'Download this page to your local project',
  'app.welcome.link.fetch-blocks': 'Get all block',
  'app.welcome.link.block-list':
    'Quickly build standard, pages based on `block` development',
  ...billing,
  ...cdn,
  ...cloak,
  ...common,
  ...globalHeader,
  ...menu,
  ...oss,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  ...pages,
  ...resourceAdmin,
  ...wallet,
};
